import { useCallback } from 'react'

import {
  PlainDatePeriod,
  dateFormat,
  disabledFutureDays,
} from 'app/common/ui-next/plain-date-period'

import { filterActions, useFilter } from '../../filterStore'

const PERIOD_LIMIT_DAYS = 30

export const PeriodControl = () => {
  const period = useFilter('period')

  const handleChange = useCallback((values: [string, string]) => {
    filterActions.selectDraftPeriod(values)
  }, [])

  const handleReset = useCallback(() => {
    filterActions.selectDraftPeriod(period.default)
  }, [period.default])

  return (
    <PlainDatePeriod
      id="period"
      label="Период времени"
      dateFrom={period.draft?.[0] ?? ''}
      dateTo={period.draft?.[1] ?? ''}
      dateFormat={dateFormat}
      periodLimit={PERIOD_LIMIT_DAYS}
      periodLimitUnit="days"
      onChange={handleChange}
      reset={handleReset}
      dateDisabledStatus={disabledFutureDays}
      skipUpperSpace
    />
  )
}
